import { MediaClient as BaseClient } from '../client'

export default class Client {
    constructor() {
        this.client = new BaseClient()
          
        this.client.http.interceptors.request.use(function(config) {
        config.headers["X-Project-Uuid"] = localStorage.getItem("current_project_uuid")
        
        return config
        }, function (error) {
        // Do something with request error
            return Promise.reject(error)
        });
    }

    http() {
        return this.client.http
    }
}